import { writeLayoutToStorage } from './launcherPersistenceService';
import { save as workspaceSave } from './adapters/workspaceAdapter';
import { save as legacySave } from './adapters/legacyLauncherAdapter';
import { flushDraftSave } from '../workspaceRuntime/workspaceDraftService';
import { RUNTIME_SOURCE, isDraftEditRole } from '../workspaceRuntime/workspaceResolverService';

/**
 * Persist a Home layout snapshot.
 * Regular users keep a personal copy (localStorage + prefs) they can add tiles to.
 * Home Designer admins also write the shared workspace draft.
 */
export function layoutHasHomeImage(snapshot) {
  return (Array.isArray(snapshot?.icons) ? snapshot.icons : []).some(
    (icon) => icon?.iconType === 'image' || icon?.iconImageAssetId
  );
}

export function persistHomeLayout({
  uid,
  role,
  runtimeContext,
  snapshot,
  flush = false,
  tenantId = '',
  readOnly = false,
}) {
  if (readOnly) return Promise.resolve({ readOnly: true });
  const workspaceId = runtimeContext?.workspaceId;
  const isWorkspace = runtimeContext?.runtimeSource === RUNTIME_SOURCE.WORKSPACE;
  const adminDraft = Boolean(isWorkspace && workspaceId && isDraftEditRole(role));
  const personal = (!adminDraft && isWorkspace && workspaceId)
    ? { ...snapshot, seededFromWorkspaceId: workspaceId, baseRevision: snapshot?.baseRevision }
    : snapshot;

  if (uid && tenantId && !adminDraft) {
    const stored = writeLayoutToStorage(uid, personal, tenantId);
    if (stored === false) {
      return Promise.reject(new Error('Could not save layout'));
    }
  }

  const imageSave = layoutHasHomeImage(snapshot) || layoutHasHomeImage(personal);

  if (adminDraft) {
    if (flush || imageSave) {
      if (imageSave) return flushDraftSave(runtimeContext, snapshot, { strict: true });
      return flushDraftSave(runtimeContext, snapshot);
    }
    return Promise.resolve(workspaceSave(runtimeContext, snapshot));
  }

  if (uid) {
    const options = { tenantId };
    if (imageSave || flush) options.immediate = true;
    return Promise.resolve(legacySave(uid, personal, options));
  }
  return Promise.resolve(null);
}
